<template>
    <div class="pt-8">
        <h2 class="font-mulish w-full lg:w-[90%]  mx-auto  text-2xl text-[#053A51] text-left font-bold mb-5">
            Uploaded Promotion Files
        </h2>
        <div class="w-full lg:w-[90%] mx-auto rounded-lg py-4 px-0">
            <div class="overflow-x-auto">
                <api-table apiUrl="/staff-promotion/bulk-upload" :fields="fields" :show-page="true" :show-search="true"
                    placeholder="Search by name, phone number or email">
                    <template slot="validationStatus" slot-scope="props">
                        <span v-if="
                            props.rowData.validationStatus === 'pending'
                        " class="text-gray-500 font-bold">
                            Pending
                        </span>
                        <span v-else-if="
                            props.rowData.validationStatus === 'failed'
                        " class="text-red-500 font-bold">
                            Failed</span>
                        <span v-else class="text-oneGreen font-bold capitalize">
                            {{ props.rowData.validationStatus }}
                        </span>
                    </template>

                    <template slot="action" slot-scope="props">
                        <span class="flex gap-2 justify-end items-center pr-2">
                            <!-- Submit button: only if successful -->
                            <button v-if="props.rowData.validationStatus === 'successful'"
                                @click="handleAction('submit', props.rowData)"
                                class="bg-green-500 text-white text-xs rounded py-1 px-2">
                                Submit
                            </button>

                            <!-- Always visible buttons -->
                            <button @click="handleAction('view', props.rowData)"
                                class="border border-[#17517E] text-[#17517E] text-xs rounded py-1 px-3">
                                View
                            </button>
                            <button @click="handleAction('download', props.rowData)"
                                class="border border-[#0090FF] text-[#0090FF] bg-[#F2F9FF] text-xs rounded py-1 px-3">
                                Download
                            </button>
                            <!-- Delete button: if successful or failed -->
                            <button
                                v-if="props.rowData.validationStatus === 'failed' || props.rowData.validationStatus === 'successful'"
                                @click="handleAction('delete', props.rowData)"
                                class="bg-[#FF00001A] text-[#FF0000] text-xs rounded py-1 px-2">
                                Delete
                            </button>

                        </span>
                    </template>

                </api-table>
            </div>
        </div>
    </div>
</template>

<script>
import { downloadFile } from "@/services/utils";
import router from '@/router';

export default {
    name: "List Promotion Bulk Upload",
    data() {
        return {
            currentPage: 1,
            perPage: 5,
            loading: false,
            error: null,
            fields: [
                {
                    name: "id",
                    title: "S/N",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "batchName",
                    title: "Batch Name",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "createdAt",
                    title: "Date of submission",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                    formatter: (val) =>
                        !val ? val : this.moment(val).format("DD-MM-YYYY"),
                },
                {
                    name: "validationStatus",
                    title: "Status",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "action",
                    title: "Action",
                    titleClass: ` text-center bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
            ],
        };
    },
    computed: {
        filteredUsers() {
            return this.users.filter((user) => {
                const matchesSearch =
                    user.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    user.uploader.toLowerCase().includes(this.searchQuery.toLowerCase());

                const matchesStatus =
                    !this.statusFilter || user.status === this.statusFilter;

                return matchesSearch && matchesStatus;
            });
        },
    },
    methods: {
        mapStatus(apiStatus) {
            switch (apiStatus) {
                case "validated":
                    return "Validated";
                case "failed":
                    return "Failed";
                case "pending":
                    return "Processing";
                default:
                    return apiStatus;
            }
        },
        async handleAction(action, user) {
            switch (action) {
                case "download":
                    await downloadFile(user.batchExcelFile, `${user.batchNo}.xlsx`);
                    break;
                case "view":
                    router.push(`/admin/promotion/bulk-upload-status/${user._id}`)
                    break;

                case "submit":
                    console.log("Submitting:", user);
                    break;

                case "delete":
                    console.log("Deleting:", user);
                    break;

                default:
                    console.log("Unknown action:", action);
            }
        },
    }
};
</script>
